const ClockComponent = () => {
  return (
    <div className="d-flex" style={{ marginRight: "21%", marginTop: "-7%" }}>
      <iframe
        src="https://free.timeanddate.com/clock/i7yk5xtn/n246/szw110/szh110/hoc000/hbw2/hfceee/cf100/hncccc/fdi76/mqc000/mql10/mqw4/mqd98/mhc000/mhl10/mhw4/mhd98/mmc000/mml10/mmw1/mmd98"
        frameBorder="0"
        width="110"
        height="110"
      ></iframe>
    </div>
  );
};

export default ClockComponent;
